<div class="bmc-pack-visualizer-topbar bz-space--stack-l">
  <div class="bmc-pack-visualizer-topbar__header">
    <bzg-icon class="bz-space--inline-m bmc-pack-visualizer-topbar__back"
              [nameIcon]="'icon-arrow-left-bold'"
              [size]="16"
              (click)="closePackageVisualizerDetail()">
    </bzg-icon>
    <div class="bmc-pack-visualizer-topbar__info">
      <h4 class="bmc-pack-visualizer-topbar__bex-name" *ngIf="!isSearchMode">
        {{packageName}}
      </h4>
      <h4 class="bmc-pack-visualizer-topbar__title-text" *ngIf="!isSearchMode">
        {{ 'PACKAGE_VISUALIZER.DISPLAY_NAME' | translate }}
      </h4>
    </div>
  </div>

  <bzg-icon class="bz-space--inline-s bmc-pack-visualizer-topbar__close-search" [nameIcon]="'icon-close-strong'"
    (click)="endSearchMode()" *ngIf="isSearchMode" [color]="'active'">
  </bzg-icon>
  <div class="bmc-pack-visualizer-topbar__right-container"
    [ngClass]="{'bmc-pack-visualizer-topbar--search-mode': isSearchMode}">
    <div class="bmc-pack-visualizer-topbar__input-field"
      [ngClass]="{'bmc-pack-visualizer-topbar--search-mode': isSearchMode}">
      <bzg-input [(ngModel)]="searchText" (keyup)="onKeyUp()" (focus)="setSearchMode(true)"
        class="bz-space--inline-m" [autocomplete]="'off'"
        [placeholder]="'PACKAGE_VISUALIZER.PLACEHOLDER_SEARCH' | translate" actionIcnPosition="left">
        <bzg-icon nameIcon="icon-search"></bzg-icon>
      </bzg-input>
    </div>
  </div>
</div>
